// src/components/HomePage.js
import React from "react";
import { Container, Grid, Box, Typography } from "@mui/material";
import StatsCard from "../components/homepage/stats/StatsCard";
import RevenueChart from "../components/homepage/Charts/RevenueCharts";
import OrdersChart from "../components/homepage/Charts/OrdersChart";
import RecentOrders from "../components/homepage/stats/RecentOrders";
import TopMechanics from "../components/homepage/stats/TopMechanics";

const HomePage = () => (
 <Container maxWidth="xl">
  <Box
   sx={{
    padding: "20px",
    // backgroundColor: "#f9f9f9",
    // borderRadius: "10px",
    // boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    marginBottom: "30px",
   }}
  >
   <Typography
    variant="h4"
    fontWeight="bold"
    color="primary"
    sx={{ marginBottom: "20px" }}
   >
    Dashboard Overview
   </Typography>
   <Grid container spacing={3}>
    <Grid item xs={12} md={4}>
     <StatsCard
      title="Total Revenue"
      value="$120K"
      subtitle="This Month"
      sx={{
       bgcolor: "#6200ea",
       color: "white",
       boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
       borderRadius: "12px",
       transition: "all 0.3s ease",
       "&:hover": {
        bgcolor: "#3700b3",
        boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.15)",
       },
      }}
     />
    </Grid>
    <Grid item xs={12} md={4}>
     <StatsCard
      title="Total Orders"
      value="480"
      subtitle="This Month"
      sx={{
       bgcolor: "#03dac6",
       color: "white",
       boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
       borderRadius: "12px",
       transition: "all 0.3s ease",
       "&:hover": {
        bgcolor: "#018786",
        boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.15)",
       },
      }}
     />
    </Grid>
    <Grid item xs={12} md={4}>
     <StatsCard
      title="Active Mechanics"
      value="35"
      subtitle=""
      sx={{
       bgcolor: "#ff5722",
       color: "white",
       boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
       borderRadius: "12px",
       transition: "all 0.3s ease",
       "&:hover": {
        bgcolor: "#e64a19",
        boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.15)",
       },
      }}
     />
    </Grid>

    {/* Charts Section */}
    <Grid item xs={12}>
     <Box
      sx={{
       backgroundColor: "white",
       padding: "20px",
       borderRadius: "12px",
       boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
      }}
     >
      <Typography
       variant="h6"
       fontWeight="bold"
       color="primary"
       sx={{ marginBottom: "20px" }}
      >
       Revenue Overview
      </Typography>
      <RevenueChart />
     </Box>
    </Grid>
    <Grid item xs={12}>
     <Box
      sx={{
       backgroundColor: "white",
       padding: "20px",
       borderRadius: "12px",
       boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
      }}
     >
      <Typography
       variant="h6"
       fontWeight="bold"
       color="primary"
       sx={{ marginBottom: "20px" }}
      >
       Order Trends
      </Typography>
      <OrdersChart />
     </Box>
    </Grid>

    {/* Recent Orders and Top Mechanics */}
    <Grid item xs={12} md={6}>
     <Box
      sx={{
       backgroundColor: "white",
       padding: "20px",
       borderRadius: "12px",
       boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
      }}
     >
      <Typography
       variant="h6"
       fontWeight="bold"
       color="primary"
       sx={{ marginBottom: "20px" }}
      >
       Recent Orders
      </Typography>
      <RecentOrders />
     </Box>
    </Grid>
    <Grid item xs={12} md={6}>
     <Box
      sx={{
       backgroundColor: "white",
       padding: "20px",
       borderRadius: "12px",
       boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
      }}
     >
      <Typography
       variant="h6"
       fontWeight="bold"
       color="primary"
       sx={{ marginBottom: "20px" }}
      >
       Top Mechanics
      </Typography>
      <TopMechanics />
     </Box>
    </Grid>
   </Grid>
  </Box>
 </Container>
);

export default HomePage;
